// Types
import { ProductProps } from 'types/Product.types';

export const shouldShowLimitedStockModal = (
  { amendQuantitiesApiCallActive = false, limitedStockItems }:
  { amendQuantitiesApiCallActive?: boolean; limitedStockItems: ProductProps[] },
): boolean => limitedStockItems?.length > 0 || amendQuantitiesApiCallActive;
